import {DialogLayout} from "base/dialog/components";

const ReturnToProcessDialog = ({
    isDialogOpen,
    setIsDialogOpen,
    onReturnToProcess,
    error = null,
}) => {
    const handleDialog = isOpen => {
        setIsDialogOpen(false);
    };

    const handleConfirm = () => {
        setIsDialogOpen(false);
        onReturnToProcess();
    };

    return (
        <DialogLayout
            dialogTitle="Devolver autorização para Em Processo?"
            dialogContentText="Esta ação devolverá a autorização aprovada para o último passo do processo (Pendente firma Direcção). Deseja continuar?"
            onMainActionClick={handleConfirm}
            mainActionText="Devolver"
            mainActionColor="warning"
            onHandleDialog={handleDialog}
            isDialogOpen={isDialogOpen}
            error={error}
        />
    );
};

export default ReturnToProcessDialog;
